import { Box, Heading, List, ListItem } from '@chakra-ui/react';
import { ArrowRightIcon } from '@udacity/chakra-uds-icons';

import { ButtonLink } from '~/components/button-link';
import { ContentContainer } from '~/components/container';
import { trackEvent } from '~/features/analytics/track-event';
import { ProgramCatalogCard } from '~/features/catalog/components/catalog-card-program';
import { CatalogItem } from '~/features/catalog/models/catalog-item';

export type ProgramListSectionProps = {
  title: string;
  programs: CatalogItem[];
  viewAllLink: string;
  limit?: number;
};
export function ProgramsListSection({ programs, title, viewAllLink, limit = 5 }: ProgramListSectionProps) {
  if (!programs?.length) return null;
  return (
    <Box as='section'>
      <ContentContainer marginY={{ base: '24px', xl: '64px' }}>
        <Heading
          as='h2'
          size={{
            base: 'h6',
            xl: 'h2',
          }}
        >
          {title}
        </Heading>
        <Box h='16px' />
        <Box
          overflow='auto'
          marginX={{
            base: '-16px',
            xl: 'unset',
          }}
        >
          <List
            display='grid'
            gridAutoFlow='column'
            gridGap='16px'
            gridAutoColumns={{
              base: '190px',
              xl: 'calc((100% - 4*24px) / 5)', // Note: 5 cards + 4 gaps of 24px
            }}
            paddingX={{
              base: '16px',
              xl: 'unset',
            }}
          >
            {programs.slice(0, limit).map((program) => (
              <ListItem key={program.key}>
                <ProgramCatalogCard
                  catalogItem={program}
                  width={{
                    base: '190px',
                    xl: '100%',
                  }}
                  onClick={() =>
                    trackEvent({
                      type: 'click',
                      name: 'Schools Page CTA Clicked',
                      label: program.title!,
                      value: title,
                    })
                  }
                />
              </ListItem>
            ))}
          </List>
          <Box
            h={{
              base: '8px',
              xl: '16px',
            }}
          />
        </Box>
        <ButtonLink
          buttonProps={{
            display: 'inline-flex',
            variant: 'link',
            gap: '2px',
            onClick: () =>
              trackEvent({
                type: 'click',
                name: 'Schools Page CTA Clicked',
                label: 'View All',
                value: title,
              }),
          }}
          linkProps={{
            href: viewAllLink,
          }}
        >
          View All <ArrowRightIcon height='20px' width='20px' />
        </ButtonLink>
      </ContentContainer>
    </Box>
  );
}
